const fancyBoxElem = document.querySelector('[data-fancybox]');

if (fancyBoxElem) {
	Fancybox.bind('[data-fancybox]', {});
}
